import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Flame } from 'lucide-react';
export type AppTab = 'claims' | 'tank';
interface TabSwitcherProps {
  active: AppTab;
  onChange: (t: AppTab) => void;
  myClaimsCount: number;
  pendingCount: number;
  tankCount: number;
  claimsRemaining: number;
  dailyCap: number;
}
export function TabSwitcher({
  active,
  onChange,
  myClaimsCount,
  pendingCount,
  tankCount,
  claimsRemaining,
  dailyCap
}: TabSwitcherProps) {
  const atCap = claimsRemaining === 0;
  const tabs: {
    key: AppTab;
    label: string;
    sublabel: string;
    icon: ComponentType<{
      className?: string;
    }>;
    count: number;
    accent: string;
  }[] = [{
    key: 'claims',
    label: 'My Claims',
    sublabel: `${pendingCount} pending follow-up`,
    icon: Briefcase,
    count: myClaimsCount,
    accent: 'orange'
  }, {
    key: 'tank',
    label: 'Shark Tank',
    sublabel: atCap ? 'Daily claim cap reached' : `${claimsRemaining} of ${dailyCap} claims left today`,
    icon: Flame,
    count: tankCount,
    accent: 'red'
  }];
  return <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-426">
      {tabs.map(t => {
      const isActive = active === t.key;
      return <button key={t.key} onClick={() => onChange(t.key)} className={`relative overflow-hidden text-left rounded-2xl border p-4 transition-all group ${isActive ? t.accent === 'orange' ? 'border-orange-500/50 bg-gradient-to-br from-orange-500/15 via-slate-900 to-slate-900' : 'border-red-500/50 bg-gradient-to-br from-red-500/15 via-slate-900 to-slate-900' : 'border-slate-800 bg-slate-900/40 hover:border-slate-700 hover:bg-slate-900/70'}`} data-id="element-427">
            {isActive && <motion.div layoutId="tab-glow" className={`absolute inset-x-0 -top-px h-px ${t.accent === 'orange' ? 'bg-orange-500' : 'bg-red-500'}`} data-id="element-428" />}
            <div className="flex items-center justify-between" data-id="element-429">
              <div className="flex items-center gap-3 min-w-0" data-id="element-430">
                <div className={`p-2.5 rounded-xl ${isActive ? t.accent === 'orange' ? 'bg-orange-500/20 text-orange-400' : 'bg-red-500/20 text-red-400' : 'bg-slate-800 text-slate-400'}`} data-id="element-431">
                  <t.icon className="w-5 h-5" data-id="element-432" />
                </div>
                <div className="min-w-0" data-id="element-433">
                  <p className={`text-base font-bold font-display ${isActive ? 'text-white' : 'text-slate-300'}`} data-id="element-434">
                    {t.label}
                  </p>
                  <p className={`text-xs ${t.key === 'tank' && atCap ? 'text-red-400 font-semibold' : 'text-slate-400'}`} data-id="element-435">
                    {t.sublabel}
                  </p>
                  {t.key === 'tank' && <div className="mt-2 flex items-center gap-1" aria-label={`${claimsRemaining} of ${dailyCap} claims remaining`} data-id="element-436">
                      {Array.from({
                  length: dailyCap
                }).map((_, i) => {
                  const filled = i < dailyCap - claimsRemaining;
                  return <div key={i} className={`h-1.5 w-6 rounded-full transition-colors ${filled ? atCap ? 'bg-red-500' : 'bg-slate-600' : 'bg-emerald-500/70'}`} data-id="element-437" />;
                })}
                    </div>}
                </div>
              </div>
              <div className={`text-2xl font-bold font-display ${isActive ? t.accent === 'orange' ? 'text-orange-400' : 'text-red-400' : 'text-slate-500'}`} data-id="element-438">
                {t.count}
              </div>
            </div>
          </button>;
    })}
    </div>;
}